import React, { useEffect, useState, useRef } from "react";
import MyButton from "../components/MyButton";

const DELAY_TIME = 500;

const Quiz = ({ changePage, setScore, numPreguntes, carrers, carrersIds }) => {
  const [answered, setAnswered] = useState(0);
  const [answer, setAnswer] = useState(undefined);
  const [correct, setCorrect] = useState(0);
  const [carrer, setCarrer] = useState({
    sentit: "muntanya",
    dir: "vertical",
    doble: "true",
    paraleles: ["error1", "error2"],
    id: "error",
  });
  const [carrersPossibles, setCarrersPossibles] = useState([
    "Marina",
    "Casanoves",
    "Calabria",
    "Rocafort",
  ]);

  const remainingCarrers = useRef(carrers || []);

  const tipusPregunta = useRef(0); // 0 = sentit, 1=paraleles

  // CONSTS
  const sentits = ["Muntanya", "Mar", "Llobregat", "Besos", "Doble"];

  // EFFECTS
  useEffect(() => {
    if (answered >= numPreguntes) {
      setScore(correct / numPreguntes);
      changePage("finish");
    } else {
      generateNewQuestion();
    }
  }, [answered]);

  useEffect(() => {
    if (answer) {
      setTimeout(() => {
        handleAnswer();
        setAnswer(undefined);
        setAnswered(answered + 1);
      }, DELAY_TIME);
    }
  }, [answer]);

  // FUNCTIONS
  const capitalizeWords = (inputString) => {
    return inputString.replace(/\b\w/g, (match) => match.toUpperCase());
  };

  const generateNewQuestion = () => {
    remainingCarrers.current = remainingCarrers.current.filter(
      (c) => c.id !== carrer.id
    );
    const newCarrer =
      remainingCarrers.current[
        Math.floor(Math.random() * remainingCarrers.current.length)
      ];
    console.log(newCarrer);

    tipusPregunta.current = Math.floor(Math.random() * 2);
    if (tipusPregunta.current === 1) {
      let auxCarrersPossibles = carrersIds.filter(
        (c) => c !== newCarrer.id && !newCarrer.paraleles.includes(c)
      );

      auxCarrersPossibles = auxCarrersPossibles
        .sort(() => 0.5 - Math.random())
        .slice(0, 3);

      let randomParalel;
      do {
        randomParalel =
          newCarrer.paraleles[
            Math.floor(Math.random() * newCarrer.paraleles.length)
          ];
      } while (randomParalel === "-");

      auxCarrersPossibles.push(randomParalel);
      setCarrersPossibles(auxCarrersPossibles);
    }
    setCarrer(newCarrer);
  };

  const handleAnswer = () => {
    if (
      answer.toUpperCase() === carrer.sentit.toUpperCase() ||
      (answer === "Doble" && carrer.doble) ||
      carrer.paraleles.includes(answer)
    ) {
      setCorrect(correct + 1);
    }
  };

  return (
    <div className="mx-10">
      <div className="flex justify-between flex-row mx-5">
        <div className="text-3xl font-bold">
          {correct}/{numPreguntes}
        </div>
        <progress className="rounded-3xl" value={answered} max={numPreguntes} />
      </div>

      <div className="my-8 text-3xl font-bold">
        {tipusPregunta.current === 0
          ? `Quin sentit té el carrer ${capitalizeWords(carrer.id)}?`
          : `Quin carrer és paral·lel al carrer ${capitalizeWords(carrer.id)}?`}
      </div>
      <div className="button-Container">
        {tipusPregunta.current === 0 &&
          sentits.map((sentit, i) => (
            <MyButton
              key={i}
              label={sentit}
              onPress={() => setAnswer(sentit)}
              color={
                answer === sentit
                  ? sentit.toUpperCase() === carrer.sentit.toUpperCase() ||
                    (answer === "Doble" && carrer.doble)
                    ? "green"
                    : "red"
                  : "yellow"
              }
            />
          ))}
        {tipusPregunta.current === 1 &&
          carrersPossibles.map((c, i) => (
            <MyButton
              key={i}
              label={capitalizeWords(c)}
              onPress={() => setAnswer(c)}
              color={
                answer === c
                  ? carrer.paraleles.includes(c)
                    ? "green"
                    : "red"
                  : "yellow"
              }
            />
          ))}
      </div>
    </div>
  );
};

export default Quiz;
